import { tool } from "ai";
import { z } from "zod";
import type { ToolSet } from "./types";

// Re-export for convenience
export { tool, z };

/** Helper to create an AI SDK tool entry (returns { name: toolDef }) */
export function createTool<T extends z.ZodObject<z.ZodRawShape>>(config: {
  name: string;
  description: string;
  inputSchema: T;
  execute: (args: z.infer<T>) => Promise<string>;
}): ToolSet {
  return {
    [config.name]: tool({
      description: config.description,
      inputSchema: config.inputSchema,
      execute: async (args) => config.execute(args as z.infer<T>),
    }),
  };
}
